import { render, staticRenderFns } from "./TripsAdd.vue?vue&type=template&id=80f960ae&scoped=true&"
import script from "./TripsAdd.vue?vue&type=script&lang=js&"
export * from "./TripsAdd.vue?vue&type=script&lang=js&"
import style0 from "./TripsAdd.vue?vue&type=style&index=0&id=80f960ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f960ae",
  null
  
)

export default component.exports